import { echartsContent, sortMapAuxiliaryFunc } from '@/pages/opinion/utils';

import { formatTimeXAxisText } from '@/pages/opinion/utils/chart';
import {
  legendFormat,
  richImgMap,
  sentimentBrandHealthLegend,
  textShowFun,
  visualMap,
} from './commonOption';
import { getAxisPointer } from '@/pages/opinion/components/EChartCommon';
import {
  formatChartParamsDate,
  listTimeTitleFunc,
} from '@/pages/opinion/components/ChartCommon/formatter';
import {
  brandHealthFormat,
  reviewsFormat,
  sentimentFormat,
} from '@/pages/opinion/utils/value';

export default function (showType: string, formatMessage: any, filter: any) {
  return {
    tooltip: {
      axisPointer: {
        type: 'line',
      },
      confine: true,
      hideDelay: 200,
      triggerOn: 'mousemove',
      padding: 0,
      className: 'mention-sentiment-tooltip-box',
      formatter: (params: any) => {
        let title = listTimeTitleFunc(
          params?.[0]?.axisValue,
          filter.date_type,
          true,
        );
        return formatChartParamsDate({
          title,
          params,
          listTitleFunc: (item) => formatMessage({ id: item.seriesName }),
          textShowFun: textShowFun(formatMessage),
          valueFormat: (value: number | string, element?: any) => {
            if (
              [
                formatMessage({ id: 'Sentiment' }),
                formatMessage({ id: 'Brand Health' }),
              ].includes(element.seriesName)
            ) {
              return element.seriesName === formatMessage({ id: 'Sentiment' })
                ? sentimentFormat(value)
                : brandHealthFormat(value);
            }

            return value === '-' ? '-' : reviewsFormat(value as number);
          },
          recordDealwith: (record, element) => {
            if (
              element.seriesName === formatMessage({ id: 'Brand Health' }) &&
              element?.data?.flag
            ) {
              return { ...record, originValue: '-' };
            }
            return record;
          },
          dealwithRecords(records) {
            records.sort(
              sortMapAuxiliaryFunc(
                {
                  [formatMessage({ id: 'Sentiment' })]: 0,
                  [formatMessage({ id: 'Brand Health' })]: 1,
                  [formatMessage({ id: `Sensor Tower ${showType}` })]: 2,
                  [formatMessage({ id: `Predicted ${showType}` })]: 3,
                },
                (item) => item.originText,
              ),
            );
            return records;
          },
        });
      },
    },
    grid: {
      right: '0%',
      bottom: '36px',
      top: '20px',
      containLabel: true,
    },
    axisPointer: getAxisPointer((data) => {
      return formatTimeXAxisText(data.value, filter?.date_type || 'daily');
    }),
    visualMap: visualMap,
    legend: {
      itemWidth: 15,
      data: [
        ...sentimentBrandHealthLegend(formatMessage),
        formatMessage({ id: `Sensor Tower ${showType}` }),
        formatMessage({ id: `Predicted ${showType}` }),
      ],
      selected: {
        [formatMessage({ id: 'Sentiment' })]: false,
      },
      formatter: (value: any) => legendFormat(value, formatMessage),
      textStyle: {
        color: '#888888',
        fontWeight: 400,
        fontSize: '12px',
        rich: {
          a: {
            color: '#888888',
            fontSize: 12,
            fontWeight: 400,
          },
          ...richImgMap,
        },
      },
    },
    xAxis: [
      {
        axisLabel: {
          formatter: (value: any) =>
            formatTimeXAxisText(value, filter?.date_type || 'daily'),
        },
        data: [],
      },
    ],
    yAxis: [
      {
        type: 'value',
        splitNumber: 5,
      },
      {
        type: 'value',
        nameTextStyle: {
          color: '#444444',
          fontWeight: 400,
          fontSize: '12px',
        },
        axisLabel: {
          formatter: (value: any) => echartsContent(value),
          color: '#838697',
        },
        splitNumber: 5,
        min: 0,
      },
    ],
    series: [
      {
        name: formatMessage({ id: 'Sentiment' }),
        type: 'line',
        yAxisIndex: 0,
        itemStyle: {
          color: '#29B569',
        },
        data: [],
      },
      {
        name: formatMessage({ id: 'Brand Health' }),
        type: 'line',
        yAxisIndex: 0,
        data: [],
      },
      {
        name: `Sensor Tower ${showType}`,
        type: 'line',
        yAxisIndex: 1,
        lineStyle: {
          color: '#5086F3',
        },
        itemStyle: {
          color: '#5086F3',
        },
        data: [],
      },
      {
        name: `Predicted ${showType}`,
        type: 'line',
        yAxisIndex: 1,
        lineStyle: {
          color: '#F8CC6A',
        },
        itemStyle: {
          color: '#F8CC6A',
        },
        data: [],
      },
      {
        name: showType,
        type: 'line',
        yAxisIndex: 1,
        lineStyle: {
          color: '#5086F3',
        },
        itemStyle: {
          color: '#5086F3',
        },
        data: [],
      },
    ],
  };
}
